import React, {useContext, useEffect, useMemo, useState} from 'react';
import styled from 'styled-components';
import BodyTree from './BodyTree';
import {labels} from '../../../../../../util/utils';
import Utility from '../../../../../../util/utilityfunctions';
import {DocumentEngagementIdContext} from '../../../../../Main/Forms/CanvasFormContainer';
import {formBodyType, WIDTH_50, WIDTH_30, clientSideEventNames, entities} from '../../../../../../util/uiconstants';
import {FormBodyTypeIdContext} from '../../FormBodyContainer';
import CompareSnapshotLabel from '../../../../CanvasForm/CompareSnapshotLabel';
import {RelatedCanvasForm} from '../../../Section/RelatedCanvasForm';
import EditADCContainer from '../../../../../Main/ADC/EditADCContainer';
import EllipsesControl from '../../../../EllipsesControl/EllipsesControl';
import {useEngagementId, useUserPreferences} from '../../../../../../util/customHooks';
import Icon from '../../../../BaseComponentWrappers/MotifIcon';
import {IconoirCustomRiskBolt} from '@ey/motif-react-wrapper/assets/icons/custom';

export default function WcgwRelatedObject(props) {
	const {data, isTopLevel, bodyId, isSnapshotView} = props;
	const [showModal, setShowModal] = useState(false),
		[nameWidth, setNameWidthDockView] = useState((window.innerWidth * WIDTH_30) / 100);
	const currentLevel = isTopLevel ? 1 : data.level;
	const engagementId = useEngagementId();
	const documentEngagementId = useContext(DocumentEngagementIdContext);
	const userPreferences = useUserPreferences();
	const formBodyTypeId = useContext(FormBodyTypeIdContext);
	const [isObjectAssociatedToOtherForm, setIsObjectAssociatedToOtherForm] = useState(false);

	const loadEdit = () => {
		if (!isSnapshotView) {
			setShowModal(true);
		}
	};

	const onCollapseChange = (e) => {
		if (e.detail.isExpanded) {
			let width = (window.innerWidth * WIDTH_30) / 100;
			setNameWidthDockView(width);
		} else {
			let width = (window.innerWidth * WIDTH_50) / 100;
			setNameWidthDockView(width);
		}
	};

	const showHideModel = (showModal) => {
		setShowModal(showModal);
	};

	const showHideIcon = () => {
		if (
			(data && data.secondaryRelatedCanvasForm && data.secondaryRelatedCanvasForm.length > 0) ||
			(data && data.primaryRelatedCanvasForm && data.primaryRelatedCanvasForm.length > 0)
		) {
			setIsObjectAssociatedToOtherForm(true);
		}
	};

	const showRiskIcon = () => {
		if (data.hasRelatedRisks) {
			if (
				formBodyTypeId &&
				formBodyTypeId > 0 &&
				(formBodyTypeId === formBodyType.WCGWTasks || formBodyTypeId === formBodyType.RelatedWCGWsSCOTs)
			) {
				return true;
			} else if (data.parentEntityId === entities.SCOT) {
				return true;
			}
		}
		return false;
	};

	const name = useMemo(() => {
		return (
			<>
				<section className="RelatedObjectTextWrapper" onClick={loadEdit}>
					<EllipsesControl
						content={data.entityName}
						tooltip={data.entityName}
						tooltipClass="tooltipCustomWidth"
						noOfLines={1}
					/>
				</section>
				{showRiskIcon(data) && (
					<section className="RelatedRiskIcon">
						<Icon className="small" size="16" src={IconoirCustomRiskBolt} title={labels.boltIconTitle} />
					</section>
				)}
				{data && data.children && data.children.length > 0 && (
					<section className="CountWrapper">
						<span>{Number(data.children.length)}</span>
					</section>
				)}
			</>
		);
	}, [data]);
	useEffect(() => {
		showHideIcon();

		window.addEventListener(clientSideEventNames.onCollapseChange, onCollapseChange);
		return () => {
			window.removeEventListener(clientSideEventNames.onCollapseChange, onCollapseChange);
		};
	}, []);

	return (
		<StyledWcgwRelatedObject
			className={`WcgwRelatedObject entity-content entity-content-level-${currentLevel}
						${formBodyTypeId === formBodyType.WCGWTasks ? 'type14' : ''}`}
		>
			<>
				<BodyTree
					isSnapshotView={isSnapshotView}
					data={data}
					bodyId={'wcgwBodyId'}
					formBodyTypeId={formBodyTypeId}
					defaultOpen
					open
					noChildrenLabel={formBodyTypeId === formBodyType.WCGWTasks ? labels.noRelatedTasks : undefined}
				>
					<section
						className={`entity-content-main WcgwRelatedObjectWrapper ${Utility.getClasstoDisableADCLink(
							userPreferences,
							isSnapshotView
						)}`}
					>
						{!isSnapshotView ? (
							<>{name}</>
						) : (
							<section className="RelatedObjectTextWrapper">
								{Utility.getHtmlTextElement(data.entityName, isSnapshotView)}
							</section>
						)}
					</section>
					{!isSnapshotView ? (
						<>
							{isObjectAssociatedToOtherForm && (
								<section className="entity-content-data FourthCol WcgwRelated">
									<RelatedCanvasForm relatedCanvasFormDetails={data} documentEngagementId={documentEngagementId} />
								</section>
							)}
						</>
					) : (
						<>{isSnapshotView && <CompareSnapshotLabel snapshotObject={data} />}</>
					)}
				</BodyTree>
				{!isSnapshotView && showModal && (
					<EditADCContainer
						showHideModel={showHideModel}
						documentEngagementId={documentEngagementId}
						engagementId={engagementId}
						bodyId={bodyId}
						item={data}
						objectEntityId={data.entityUId}
					/>
				)}
			</>
		</StyledWcgwRelatedObject>
	);
}

const StyledWcgwRelatedObject = styled.section`
	&.entity-content {
		&.entity-content-level-4 {
			width: 100%;
			.WcgwRelatedObjectWrapper {
				&.disableLinksExternalUsers {
					pointer-events: none;
				}
			}
		}
		&.entity-content-level-1 {
			padding: var(--px-5) var(--px-10) !important;
			&.type14 {
				padding: var(--px-5) 0 !important;
				button {
					.motif-tree-trigger-icon {
						display: none;
					}
				}
				.entity-content-main {
					width: 100% !important;
					.RelatedObjectTextWrapper {
						max-width: calc(100% - var(--px-80));
					}
					.RelatedRiskIcon {
						display: inline-block;
						margin-right: var(--px-5);
						svg {
							margin-top: 0 !important;
							cursor: default;
							width: var(--px-16);
							height: var(--px-16);
							color: var(--neutrals-800);
							path {
								fill: currentColor;
							}
						}
					}
				}
				.entity-content-data {
					display: none;
				}
			}
		}
	}
	.WcgwRelated {
		svg {
			width: var(--px-20) !important;
			height: var(--px-20) !important;
			margin: 0 !important;
		}
	}
	.WcgwRelatedObjectWrapper {
		display: flex !important;
		width: 85%;
		.RelatedObjectTextWrapper {
			align-items: flex-start !important;
			.diffins {
				background-color: #e6ffe6;
				font-family: inherit;
				text-decoration: none;
			}
			.diffdel {
				color: #999;
				background-color: #ffe6e6;
				font-family: inherit;
			}
			.mod {
				background-color: #ffe1ac;
				font-family: inherit;
			}
		}
		.RelatedRiskIcon {
			display: inline-flex;
			margin-right: var(--px-5);
			svg {
				width: var(--px-16);
				height: var(--px-16);
				color: var(--neutrals-800);
				path {
					fill: currentColor;
				}
			}
		}
		.CountWrapper {
			margin-left: var(--px-10);
			margin-top: var(--px-3);
			@media only screen and (max-width: 1280px) {
				margin-top: var(--px-5);
			}
		}
		&.disableLinksExternalUsers {
			pointer-events: none;
		}
	}
	.motif-tree {
		.WcgwRelatedObjectWrapper {
			.RelatedObjectTextWrapper {
				padding-left: 0;
			}
		}
		&.disableLinksExternalUsers {
			pointer-events: none;
		}
	}
	&.type14 {
	}
	&.entity-content.entity-content-level-4 {
		width: 100%;
		.WcgwRelatedObjectWrapper {
			margin-left: var(--px-10);
		}
		&.disableLinksExternalUsers {
			pointer-events: none;
		}
	}
`;
